import React from "react";
import Icon from "../Icon/Icon";

import styles from "./AuthDrawer.css";

const ForgotPasswordTwo = () => {
  return (
    <div className={styles.container}>
      <div className={styles.textCenter}>
        <Icon className={styles.checkmark} name="check/rounded" />
      </div>

      <h3 className={styles.marginTop20}>Email sent!</h3>

      <div className={styles.marginTop20}>
        You should receive instructions on resetting your password shortly. If you don't receive an email, please make sure you've entered the address you've registered, and check your spam folder.
      </div>
    </div>
  );
};

export default ForgotPasswordTwo;



// WEBPACK FOOTER //
// ./src/components/Library/AuthDrawer/ForgotPasswordTwo.js